import { createContext } from 'react';
import { LDClient } from 'launchdarkly-js-client-sdk';

export interface Client {
    ldClient: LDClient
}

export const ChrLdContext = createContext({} as Client);